import { RotateCcw } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ListingEmptyProps {
  title: string
  description: string
  onReset: () => void
  className?: string
}

/** Bordered empty state shown when the active filters match nothing. */
export function ListingEmpty({ title, description, onReset, className }: ListingEmptyProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-start gap-5 border border-[var(--color-landing-gray-300)] p-8 md:p-12 dark:border-[var(--color-landing-gray-700)]',
        className
      )}
    >
      <p className="font-[family-name:var(--font-landing-display)] text-lg uppercase leading-[1.45] tracking-[-0.02em] text-[var(--color-landing-gray-900)] dark:text-white">
        {title}
      </p>
      <p className="landing-text-body-sm max-w-[45ch] text-[var(--color-landing-gray-900)]/65 dark:text-white/65">
        {description}
      </p>
      <button type="button" onClick={onReset} className="landing-cta landing-cta--outline landing-cta--sm landing-btn-sweep">
        <RotateCcw aria-hidden className="h-4 w-4" />
        Reset filters
      </button>
    </div>
  )
}
